// open url in new window
export var openUrlWithNewWindow = function openUrlWithNewWindow(url) {
  if (!url) return;
  window.open(url, '_blank', 'noopener,noreferrer');
}; // open url in current window

export var openUrl = function openUrl(url) {
  if (!url) return;
  window.location.href = url;
};
export var appendPromotionQuoteUrlPrameters = function appendPromotionQuoteUrlPrameters(params, data) {
  if (!params) {
    return;
  }

  var utmSource = data.utmSource,
      utmMedium = data.utmMedium,
      utmCampaign = data.utmCampaign,
      promotionId = data.promotionId,
      displayInsurance = data.displayInsurance,
      providerCode = data.providerCode,
      firstUseEnglishLanguage = data.firstUseEnglishLanguage;

  if (utmSource) {
    params['utm_source'] = utmSource;
  }

  if (utmMedium) {
    params['utm_medium'] = utmMedium;
  }

  if (utmCampaign) {
    params['utm_campaign'] = utmCampaign;
  }

  if (promotionId) {
    params['promotion_id'] = promotionId;
  }

  if (displayInsurance) {
    params['display_insurance'] = displayInsurance;
  }

  if (providerCode) {
    params['providerCode'] = providerCode;
  }

  if (firstUseEnglishLanguage) {
    params['firstUseEnglishLanguage'] = true;
  }
};
export var getCurrentReturnTo = function getCurrentReturnTo(router) {
  if (true) {
    return "".concat(window.location.pathname).concat(window.location.search).concat(window.location.hash) || '/';
  }

  return (router === null || router === void 0 ? void 0 : router.asPath) || '/';
};
export var isLogoutSyncPagePath = function isLogoutSyncPagePath(pathname) {
  return pathname === '/auth/logout-sync';
}; // open url in new window, If it is an embedded iframe, an event will be triggered

export var openUrlWithNewWindowOrEmitIframeEvent = function openUrlWithNewWindowOrEmitIframeEvent(url) {
  if (!url) return;

  if (sessionStorage.getItem('website-open-quote-iframe') && window.self !== window.top) {
    var _window$parent;

    (_window$parent = window.parent) === null || _window$parent === void 0 ? void 0 : _window$parent.postMessage(JSON.stringify({
      openUrl: true,
      url: url
    }), '*');
  } else {
    window.open(url, '_blank');
  }
};